import React, { FC, ReactElement, FormEvent, useState } from 'react';
import { sendQuestionMessage } from '../../../../api';
import { useSelector } from 'react-redux';
import { getEventKey } from '../../../../stores/reducers/userData';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import './sponsor-form.sass';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
import { internalizationState } from '../../../../stores/reducers/sections';

interface Props {
  recepient: string
}

const SponsorQuestionForm: FC<Props> = ({ recepient }): ReactElement => {
  const [ message, setMessage ] = useState<string>('');
  const eventKey = useSelector(getEventKey);
  const location = useLocation();
  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    successMessageSend_ru: 'Сообщение успешно отправлено',
    successMessageSend_en: 'Message sent successfully',
    errorMessageSend_ru: 'Ошибка отправки сообщения',
    errorMessageSend_en: 'Error sending message',
    questionTitle_ru: `Есть вопрос ${recepient ? `про ${recepient.toLowerCase()}` : ''}?`,
    questionTitle_en: `Have a question ${recepient ? `about ${recepient.toLowerCase()}` : ''}?`,
    message_ru: 'Сообщение',
    message_en: 'Message',
    sendMesageButtonTitle_ru: 'Задать вопрос',
    sendMesageButtonTitle_en: 'Ask a question',
    send_ru: 'Отправить',
    send_en: 'Send',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);

  const handlerSend = ((event: FormEvent): void => {
    event.preventDefault();
    const payload = {
      page: location.pathname.split('/')[1],
      to: recepient,
      message
    };
    sendQuestionMessage(eventKey, payload)
      .then(response => {
        if (response.status === 200) {
          toast.success(localizedName('successMessageSend_ru'))
          setMessage('')
        } else {
          toast.error(localizedName('errorMessageSend_ru'))
        }
      })
      .catch(error => {
        toast.error(localizedName('errorMessageSend_ru'))
      });
  });

  return (
    <>
      <div id="sponsor-form" className="sponsor-form-container">
        <div className="form-title">
          <h2>{ localizedName('sendMesageButtonTitle_ru') }</h2>
        </div>

        <form className="sponsor-form" onSubmit={(e) => handlerSend(e)}>
          <label className="sponsor-input-wrapper w-100">
            <span className="sponsor-input__label">{ localizedName('message_ru') }</span>                
            <textarea 
              id="message" 
              name="message" 
              className="sponsor-input__field textfield"
              onChange={(e) => setMessage(e.target.value)}
            />
          </label>
          
          <button className="btn btn-primary btn--mobile-min bg-footer sponsor-form__btn" type="submit">
            { localizedName('send_ru') }
          </button>
        </form>  
      </div>
    </>
  )
}

export default SponsorQuestionForm;
